import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Refresh = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="refresh icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M4.5 12C4.5 7.85786 7.85786 4.5 12 4.5C13.5811 4.5 15.0483 4.98861 16.2587 5.82515L14.6039 7.11806C13.9745 7.60979 14.1471 8.60453 14.9054 8.85544L21.9764 11.1953C22.6539 11.4195 23.3414 10.8824 23.2877 10.1708L22.728 2.74373C22.668 1.94729 21.7446 1.53915 21.1152 2.03087L19.5064 3.28779C17.4932 1.55194 14.8696 0.5 12 0.5C5.64872 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64872 23.5 12 23.5C15.9891 23.5 19.5026 21.4672 21.5623 18.3903C22.1767 17.4724 21.9307 16.2302 21.0128 15.6158C20.0949 15.0013 18.8527 15.2474 18.2382 16.1653C16.8894 18.1803 14.5984 19.5 12 19.5C7.85786 19.5 4.5 16.1421 4.5 12Z"
    />
  </svg>
)
